import { render, staticRenderFns } from "./ProfileFieldEditForm.vue?vue&type=template&id=0b859dbc&scoped=true"
import script from "./ProfileFieldEditForm.vue?vue&type=script&lang=js"
export * from "./ProfileFieldEditForm.vue?vue&type=script&lang=js"
import style0 from "./ProfileFieldEditForm.vue?vue&type=style&index=0&id=0b859dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b859dbc",
  null
  
)

export default component.exports